import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";

import color from "../../../../constants/color";

export const SectionContent = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div`
  padding: 0px 32px;
  display: flex;
  justify-content: space-between;

  /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
  }

  /* Modal Content (Image) */
  .modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
  }

  /* Caption of Modal Image (Image Text) - Same Width as the Image */
  #caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
  }

  /* Add Animation - Zoom in the Modal */
  .modal-content,
  #caption {
    animation-name: zoom;
    animation-duration: 0.6s;
  }

  @keyframes zoom {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }

  /* The Close Button */
  .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

  /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px) {
    .modal-content {
      width: 100%;
    }
  }
`;

export const Shortcuts = styled.div`
  position: relative;
  padding: 0px 32px;
  .swiper {
    .swiper-wrapper {
    }
    .swiper-slide {
      width: 100%;
      max-width: 238px;
    }
    .swiper-pagination {
      position: relative;
      margin-top: 15px;
      align-items: center;
      display: flex;
      justify-content: center;

      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        margin: 0px 2px;
      }

      .swiper-pagination-bullet-active {
        width: 8px;
        height: 8px;
        background: ${color.primary};
      }
    }
  }
`;

export const ShortcutsTitle = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: ${color.fullBlack};
  margin-bottom: 32px;
  z-index: 1;
  position: relative;

  &.titleBday {
    margin-bottom: 16px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &.notifications-header {
    margin-bottom: 32px;
  }
`;

interface Props {
  url: string;
}

export const ShortcutCard = styled.img`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0px 2px 2px rgba(102, 102, 102, 0.2);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  height: 120px !important;
  z-index: 1;
  position: relative;
  width: 100%;
  max-width: 238px;
  margin-bottom: 8px;
  &:hover {
    cursor: pointer;
  }
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eaefff;
  border-radius: 50%;
  margin-bottom: 10px;
  width: 32px;
  height: 32px;
  margin-top: 8px;

  &:hover {
    cursor: pointer;
  }
`;

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  box-shadow: none;
  background: none;
  flex-direction: row;
  padding: 0;
`;

export const ModalImage = styled.img`
  width: 100%;
  object-fit: contain;
`;

export const ModalHeader = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 400px;
  box-shadow: 24;
  border-radius: 8px 8px 0px 0px;
`;

export const ButtonArrow = styled(IconButton)`
  height: 40px;
  width: 40px;
  background-color: #eaefff;
  margin-top: 50px;
`;

export const ButtonSmall = styled.button`
  height: 32px;
  width: 32px;
  background-color: #eaefff;
  border: none;
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
  &:hover {
    cursor: pointer;
  }
`;

export const ContainerModal = styled.div`
  background-color: red;
  padding: 50px;
`;

export const ContainerImage = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 16px;
`;

export const RowReverse = styled.div`
  display: flex;
  flex-direction: row-reverse;
  height: 50px;
  align-items: center;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px;
`;
